<template>


  <v-app v-if="!isExpired()">
    <hasVisited :projectKey="projectKey" :phoneNumber="phoneNumber" />

    <!-- <MyYoutube videoId="vVUJDFEYv1c" /> -->
    <arrayYoutube :urls="selectedProject.header_youtube" :projectPath="selectedProject.projectPath" />
    <arrayVideo :urls="selectedProject.header_video" :projectKey="selectedProject.projectKey" />
    <BlogPost v-if="selectedProject && selectedProject.blog" :blogTitle="selectedProject.blog.title"
      :blogContent="selectedProject.blog.content" />

    <!-- <BlogPost :blogTitle="selectedProject.blog.title" :blogContent="selectedProject.blog.content" /> -->

    <!-- <h3 v-if="!isProduction">v 1.00</h3> -->
    <!-- <h1>Project: {{ selectedProject.projectName }}</h1> -->

    <h1 v-if="!isProduction">Header</h1>
    <arrayImage v-if="selectedProject.header_img.length > 0" :urls="selectedProject.header_img"
      :projectPath="selectedProject.projectPath" />

    <h1 v-if="!isProduction">Exterior View</h1>
    <arrayImage v-if="selectedProject.exteriorview_img.length > 0" :urls="selectedProject.exteriorview_img"
      :projectPath="selectedProject.projectPath" />


    <h1 v-if="selectedProject.rentalinformation_img.length > 0">Surrounding Rental Information</h1>
    <arrayImage v-if="selectedProject.rentalinformation_img.length > 0" :urls="selectedProject.rentalinformation_img"
      :projectPath="selectedProject.projectPath" />


    <!-- <htmlDisplay file="test.html" /> -->
    <div class="row-container">
      <h2 v-if="!isProduction">Proposal</h2>
      <HtmlStr :htmlString="selectedProject.header" />
      <img class=".rounded-image" src="https://res.cloudinary.com/alvin-tan/image/upload/vic/mkfahj6fmetgpp9fbubw.jpg"
        alt="Description of the image" style="width: 10%;">


      <HtmlStr :htmlString="selectedProject.header2" />
      <!-- <HtmlStr :htmlString="selectedProject.header3" /> -->
    </div>

    <h2 v-if="!isProduction">Mockup</h2>
    <arrayImage v-if="selectedProject.mockup_img.length > 0" :urls="selectedProject.mockup_img"
      :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Site Plan Image</h2>
    <arrayImage v-if="selectedProject.siteplan_img.length > 0" :urls="selectedProject.siteplan_img"
      :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Site Plan PDF</h2>
    <arrayPdf v-if="selectedProject.siteplan_pdf.length > 0" :urls="selectedProject.siteplan_pdf"
      :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Floor Plan</h2>
    <arrayImage v-if="selectedProject.floor_plan_img.length > 0" :urls="selectedProject.floor_plan_img"
      :projectPath="selectedProject.projectPath" />

    <div class="row">
      <h2>Floor Plan&nbsp;&nbsp;</h2>
      <img
        src="https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/f6/e6/6f/f6e66ffa-67d3-4de7-d716-a979ab67f6f0/ReleaseAppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/230x0w.webp"
        style="width: 2%; border-radius: 50%;" alt="Icon" class="icon">
    </div>

    <arrayPdf :urls="selectedProject.floor_plan_pdf" :projectPath="selectedProject.projectPath" />

    <h2 v-if="!isProduction">Show Room Image</h2>
    <arrayImage v-if="!isProduction" :urls="selectedProject.showroom_img" :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Show Room Video</h2>
    <arrayVideo v-if="!isProduction" :urls="selectedProject.showroom_video" :projectKey="selectedProject.projectKey" />
    <h2 v-if="!isProduction">Facilities</h2>
    <arrayImage v-if="!isProduction" :urls="selectedProject.facilities_img"
      :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Allocation PDF</h2>
    <arrayPdf v-if="!isProduction" :urls="selectedProject.allocation_pdf" :projectPath="selectedProject.projectPath" />
    <div v-if="!isProduction">
      <h2 v-if="!isProduction">General Information</h2>
      <arrayImage :urls="selectedProject.general_img" :projectPath="selectedProject.projectPath" />
      <h2 v-if="!isProduction">General Video</h2>
      <arrayVideo v-if="!isProduction" :urls="selectedProject.general_video" :projectKey="selectedProject.projectKey" />

      <div class="row">
        <h2 v-if="!isProduction">General Information&nbsp;&nbsp;</h2>
        <img
          src="https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/f6/e6/6f/f6e66ffa-67d3-4de7-d716-a979ab67f6f0/ReleaseAppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/230x0w.webp"
          style="width: 2%; border-radius: 50%;" alt="Icon" class="icon">

      </div>
      <arrayPdf :urls="selectedProject.general_pdf" :projectPath="selectedProject.projectPath" />
    </div>
    <!-- <arrayVideo :urls="selectedProject.videourls" /> -->
    <div v-if="!isProduction" class="row">
      <h2>Price List&nbsp;&nbsp;</h2>
      <img
        src="https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/f6/e6/6f/f6e66ffa-67d3-4de7-d716-a979ab67f6f0/ReleaseAppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/230x0w.webp"
        style="width: 2%; border-radius: 50%;" alt="Icon" class="icon">

    </div>
    <arrayPdf :urls="selectedProject.pricelist_pdf" :projectPath="selectedProject.projectPath" />
    <!-- <h2>Booking Form</h2>
    <arrayPdf :urls="selectedProject.booking_pdf"  :projectPath="selectedProject.projectPath"/> -->
    <h2 v-if="!isProduction">Panel Backers</h2>

    <arrayImage v-if="!isProduction" :urls="selectedProject.panel_backers_img"
      :projectPath="selectedProject.projectPath" />

    <h2 v-if="!isProduction">Developer</h2>
    <arrayImage :urls="selectedProject.developer_img" :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Amenities</h2>
    <arrayImage :urls="selectedProject.amenities_img" :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Location</h2>
    <arrayImage :urls="selectedProject.location_img" :projectPath="selectedProject.projectPath" />
    <h2 v-if="!isProduction">Introduction</h2>
    <arrayImage :urls="selectedProject.introduction_img" :projectPath="selectedProject.projectPath" />
    <!-- <h2>Private</h2>
    <arrayPdf :urls="selectedProject.private_pdf" :projectPath="selectedProject.projectPath" /> -->

    <ImageGallery />
    <ImageGalleryLocal :folder="projectName" />

    <AccessibilityInfo />

    <LaunchButton v-if="showLaunchButton" />
    <simpleForm :project="projectName" />
    <div class="image-container">
      <img v-if="projectKey.toLowerCase() == `springvale`" class="rounded-image"
        src="https://res.cloudinary.com/alvin-tan/image/upload/w_200,h_200/vic/plez2zgntinqmh9td1od.png"
        alt="Sample Image">

      <!-- <h1>{{projectKey}}</h1> -->
      <img v-if="projectKey.toLowerCase() == `acadia`" class="rounded-image"
        src="https://res.cloudinary.com/alvin-tan/image/upload/w_200,h_200/vic/yqq97j787vd2km30abos.png"
        alt="Sample Image">
      <div class="text-container">
        <p> “Hi, My name is Pinky, Please feel free to reach out to me via WhatsApp, if you need any further assistance.
          I'm here to help and happy to answer any questions or provide additional support you may require. Don't
          hesitate to contact me if you have any doubts or if there's anything else I can assist you with. Looking
          forward to assisting you further!”</p>
      </div>
    </div>
    <!-- <InterestReg /> -->
    <!-- <surveyForm /> -->
    <!-- <MyChart /> -->
    <div v-if="!isProduction">
      <FaAcadia />
      <MyFlow />


    </div>

    {{ adDuration() }}
  </v-app>
  <v-app v-if=isExpired()>
    <img src="https://res.cloudinary.com/alvin-tan/image/upload/vic/skwitgigbv5wv7df5j7c.jpg" alt="Image">
    <img style="width: 50%;" src="https://res.cloudinary.com/alvin-tan/image/upload/vic/e6njqotl4gixazgsy71a.png"
      alt="Image">

    <p style="color: blue;">This detailed documentation of Project ABC is tailored for a quick review and will expire
      today, as we are updating it to include more detailed information. However, you can prolong your access by simply
      sending us a 'Y' via WhatsApp at mobile number: 01126355988, significantly extending your viewing time. We hope
      this information proves useful to you..</p>
    <br>
    <br>
    <p style="color: green;">Dokumentasi terperinci Projek ABC ini direka untuk ditinjau dengan cepat dan akan tamat
      hari ini kerana kami perlu mengemas kini untuk menambah maklumat yang lebih terperinci. Walau bagaimanapun, anda
      boleh memanjangkan masa pemandangan anda dengan hanya menghantar 'Y' melalui WhatsApp di nombor telefon bimbit:
      01126355988, dan akses anda akan diperpanjang dengan ketara. Kami berharap maklumat ini berguna untuk anda.</p>
    <br>
    <br>
    <p style="color: maroon;">这份关于项目ABC的详细文档旨在进行快速审核，今天将过期，因为我们需要更新以添加更多详细信息。然而，您可以通过简单地通过WhatsApp发送 'Y'
      至手机号码：01126355988 来延长您的查看时间，您的访问权限将得到显著延长。我们希望这些信息对您有所帮助。</p><br>
    <br>
    {{ adDuration() }}
  </v-app>
</template>

<script>

import hasVisited from './hasVisited.vue';
// import sendWhatApp from './sendWhatApp.vue';
import BlogPost from '@/components/BlogPost.vue';
import FaAcadia from './FaAcadia.vue';
// import InterestReg from './InterestReg.vue';
// import MyYoutube from './MyYoutube.vue';
//import MyChart from './MyChart.vue';
import arrayImage from './arrayImage.vue';
import arrayYoutube from './arrayYoutube.vue';
import arrayPdf from './arrayPdf.vue';
import arrayVideo from './arrayVideo.vue';
// import htmlDisplay from './htmlDisp.vue';
//import VideoPlayer from './VideoPlayer.vue';
import HtmlStr from './HtmlStr.vue';
//import arrayCarousel from './arrayCarousel.vue'; // Assuming the file name is MyApple.vue
// import surveyForm from './surveyForm';

import DataSpringVale from './DataSpringVale.json'; // Import the JSON file
import DataNexus from './DataNexus.json'; // Import the JSON file
import DataAcadia from './DataAcadia.json'; // Import the JSON file
import DataTm from './DataTm.json'; // Import the JSON file

import simpleForm from './simpleForm.vue'; // Import the JSON file


export default {

  components: {
    hasVisited,
    // testYoutube,
    // sendWhatApp,
    BlogPost,
    simpleForm,
    //  MyYoutube,
    // InterestReg,
    FaAcadia,
    //  MyChart,
    arrayImage,
    arrayPdf,
    arrayVideo,
    arrayYoutube,
    //  arrayCarousel,
    //    htmlDisplay,


    HtmlStr,
    // surveyForm
  },
  mounted() {
    // Call the function to format the current date
    this.formatCurrentDate();
  },
  methods: {
    toggleChildComponent() {
      this.showChildComponent = !this.showChildComponent; // toggle the boolean
    },
    isExpired() {
      if (this.adDuration() > 48)
        return true;
      else
        return false;
    },
    adDuration() {
      let currenthour = this.getCurrentTotalHours();
      let oldhourstr = this.convertLetterStringToNumbers(this.urlParam.slice(3, 9));
      let oldhour = this.convertToHour(oldhourstr);
      let hour = currenthour - oldhour;
      if (this.urlParam.slice(0, 3) == "prj") {
        hour = 0;
        return hour;
      }
      if (this.urlParam.slice(0, 3) == "gyp") {
        let currenthour = this.getCurrentTotalHours();
        let oldhourstr = this.convertLetterStringToNumbers(this.urlParam.slice(3, 9));
        let oldhour = this.convertToHour(oldhourstr);
        let hour = currenthour - oldhour;
        return hour;
      }
      else
        return hour;
    },
    getCurrentTotalHours() {
      const now = new Date();

      const currentMonth = now.getMonth() + 1; // Months are zero-based, so add 1
      const currentDay = now.getDate();
      const currentHour = now.getHours();

      // Calculate the total hours from the beginning of the year
      const hoursFromMonths = (currentMonth - 1) * 30 * 24; // Approximate 30 days per month
      const hoursFromDays = (currentDay - 1) * 24;
      const totalHours = hoursFromMonths + hoursFromDays + currentHour;

      return totalHours;
    },
    convertToHour(str) {
      // Extract month, day, and hour from the string
      const month = parseInt(str.substr(0, 2));
      const day = parseInt(str.substr(2, 2));
      const hour = parseInt(str.substr(4, 2));

      // Convert month and day to hours and sum them up with the given hour
      const totalHour = (month - 1) * 30 * 24 + (day - 1) * 24 + hour;

      // Return the total hour
      return totalHour;
    },
    formatCurrentDate() {
      // Get today's date
      const currentDate = new Date();

      // Format the current date
      this.formattedDate = this.formatDateToString(currentDate);
    },
    numberToLetter(num) {
      return String.fromCharCode(97 + parseInt(num));
    },
    letterToNumber(letter) {
      return letter.charCodeAt(0) - 97;
    },
    convertNumberStringToLetters(numberStringInput) {
      if (/^\d+$/.test(numberStringInput)) {
        return `${[...numberStringInput].map(this.numberToLetter).join('')}`;
      } else {
        return 'Please enter a valid string of digits.';
      }
    },
    convertLetterStringToNumbers(letterStringInput) {
      if (/^[a-z]+$/.test(letterStringInput)) {
        return `${[...letterStringInput].map(this.letterToNumber).join('')}`;
      } else {
        return 'Please enter a valid string of lowercase letters.';
      }
    },
    formatDateToString(date) {
      // Get month and date from the date object
      const month = date.getMonth() + 1; // Month starts from 0, so add 1
      const day = date.getDate();
      const hr = date.getHours();

      // Convert month and day to string
      const monthStr = month < 10 ? '0' + month : month.toString();
      const dayStr = day < 10 ? '0' + day : day.toString();
      const hrStr = hr < 10 ? '0' + hr : hr.toString();
      // Combine month and day strings
      let formattedDate = monthStr + dayStr + hrStr;

      // Increase each character by 1 ASCII value
      let ss = this.convertNumberStringToLetters(formattedDate);
      // ss = ss + this.convertLetterStringToNumbers(ss)
      return ss;
    }
  },
  props: {
    urlParam: {
      type: String,
      required: true,
    }
  },
  data() {

    return {
      showChildComponent: false,
      formattedDate: '',
      isProduction: process.env.VUE_APP_ENV === 'production',


      blog: {
        title: "Maximizing Rental Yield: Navigating the High-Priced Property Market",
        content: "Given the current scenario of soaring property prices, it's crucial to consider investment options that promise substantial rental yields. While the market may seem daunting with properties priced at around 700k, prioritizing investments with a return yield of over 10% can be a game-changer. Instead of succumbing to FOMO, focus on properties that offer good rental yield potential, even if they are not in the early phases of development. This strategic approach can help you make a prudent decision amidst the frenzy of the property market."
      },


      imageData: [...DataSpringVale, ...DataNexus, ...DataTm, ...DataAcadia], // Use the imported JSON data
      showLaunchButton: false,
      //    notionVideoLink: 'https://file.notion.so/f/f/168abcb4-3782-43cf-966c-1436aa07fb5e/6ee13ce4-9afa-4aac-8559-45fa3bf111a5/nexustaman_pertama.mp4?id=84b87b49-c0ec-4973-96cb-41052204f2ad&table=block&spaceId=168abcb4-3782-43cf-966c-1436aa07fb5e&expirationTimestamp=1717480800000&signature=tDXUxLYaVzikfl2wuFgifvW610Z1W3wiW3o7v5m8Guk&downloadName=nexus%40taman+pertama.mp4',
      //  notionVideoLink:   'https://file.notion.so/f/f/168abcb4-3782-43cf-966c-1436aa07fb5e/83fa0d72-dc26-4a68-8ad0-e70b06672b1d/showroom.mp4?id=e3d45a6a-5dc0-411e-b3bc-1fb56476d8d3&table=block&spaceId=168abcb4-3782-43cf-966c-1436aa07fb5e&expirationTimestamp=1717473600000&signature=p16wToiTMHLKTuova-pnXLEO2G3G91s9l6ZgAtRHA8s&downloadName=showroom.mp4'
      //  notionVideoLink: 'https://third-addition-a89.notion.site/Victova-b419ec46b07a49f7aabfe010ff62e4d6'
      //      notionVideoLink:'https://file.notion.so/f/f/168abcb4-3782-43cf-966c-1436aa07fb5e/08f0c4bc-ec08-4d1a-aebe-ffe461b1a6ea/VID_20240115_204751.mp4?id=f94ab74d-f708-44e5-8577-8e5632c23462&table=block&spaceId=168abcb4-3782-43cf-966c-1436aa07fb5e&expirationTimestamp=1717459200000&signature=V9h2yNe1p0JXUW0sQ_0suHzIOLTME3eTxoTO3aoLiRo&downloadName=VID_20240115_204751.mp4'
      // videoUrl: 'https://file.notion.so/f/f/168abcb4-3782-43cf-966c-1436aa07fb5e/5fc7fdeb-c64b-46e0-92d6-1378fa2a48cd/NEXUS_Taman_Pertama.mov?id=c6678f2d-e9ef-4601-b4b2-fca29279e55d&table=block&spaceId=168abcb4-3782-43cf-966c-1436aa07fb5e&expirationTimestamp=1717480800000&signature=I81h8PHOUIgQ0gWS3QixTA-_VBWk1SpwunkHsNYHgTI'
      //  videoUrlionVideoLink:'https://file.notion.so/f/f/168abcb4-3782-43cf-966c-1436aa07fb5e/08f0c4bc-ec08-4d1a-aebe-ffe461b1a6ea/VID_20240115_204751.mp4?id=f94ab74d-f708-44e5-8577-8e5632c23462&table=block&spaceId=168abcb4-3782-43cf-966c-1436aa07fb5e&expirationTimestamp=1717459200000&signature=V9h2yNe1p0JXUW0sQ_0suHzIOLTME3eTxoTO3aoLiRo&downloadName=VID_20240115_204751.mp4'

    };
  },
  computed: {

    projectName() {
      if (this.urlParam.slice(0, 3) === "prj")
        return this.urlParam.slice(3);
      else
        return this.urlParam.slice(9);
    },
    projectKey() {

      if (this.urlParam.slice(0, 3) === "prj")
        return this.urlParam.slice(3);
      else
        return this.urlParam.slice(21);
    },
    phoneNumber() {
      if (this.urlParam.slice(0, 3) === "gyp")
        return this.urlParam.slice(9, 21);
      else
        return "123456789012";
    },

    selectedProject() {
      return this.imageData.find(item => item.projectKey.toLowerCase() === this.projectKey.toLowerCase()) || { urls: [] };
    }
  }
}
</script>

<style>
.row {
  display: flex;
  align-items: center;
  /* Center items vertically */
}

.outlined {
  border: 2px solid green;
  border-radius: 8px;
  padding: 5px;
}


.row-container>* {
  flex: 1 1 100%;
  /* Default to full width */
  box-sizing: border-box;
  /* Ensure padding and borders are included in the width/height */
}

.html-container {
  flex: 1;
  /* Each HtmlStr takes equal width */
  padding: 20px;
  background-color: darkblue;
  color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: left;
  /* Left justify the text */
  border-radius: 15px;
  /* Rounded corners */
  margin: 5px;
  /* Reduce the gap between the containers */
}

.html-container ul {
  list-style-type: disc;
  /* Use bullets for list items */
}

.form-container {
  /* Add any additional styling for the form container */
}

.image-container {
  display: flex;
  align-items: center;
}

.rounded-image {
  width: 30%;
}

.rounded-image2 {
  width: 10%;
}

.text-container {
  margin-left: 10px;
  /* Adjust as needed */
}
</style>
